import { useLocalStorage } from '../../../../utils/useLocalStorage';

export const useReloadRestore = () => {
  const [appDetailReportTabFocus = { root: 0, overview: 0, network: 0 }, setAppDetailReportTabFocus] = useLocalStorage(
    'appDetailReportTabFocus',
    { root: 0, overview: 0, network: 0 },
  );
  const [settingsTabFocus = { root: '0' }, setSettingsTabFocus] = useLocalStorage('settingsTabFocus', { root: '0' });
  const [restoredFilters = {}, setRestoredFilters] = useLocalStorage('restoredFilters', {});
  const [shouldRestore = false, setShouldRestore] = useLocalStorage('shouldRestore', false);
  const [restoredSearchQuery = '', setRestoredSearchQuery] = useLocalStorage('restoredSearchQuery', '');
  return {
    appDetailReportTabFocus,
    setAppDetailReportTabFocus,
    settingsTabFocus,
    setSettingsTabFocus,
    restoredFilters,
    setRestoredFilters,
    shouldRestore,
    setShouldRestore,
    restoredSearchQuery,
    setRestoredSearchQuery,
  };
};
